// Badge color mappings using shadcn/ui equivalent classes
export const badgeColors = {
    red: 'bg-red-100 text-red-800 border-red-300',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    green: 'bg-green-100 text-green-800 border-green-300',
    blue: 'bg-blue-100 text-blue-800 border-blue-300',
    indigo: 'bg-indigo-100 text-indigo-800 border-indigo-300',
    purple: 'bg-purple-100 text-purple-800 border-purple-300',
    pink: 'bg-pink-100 text-pink-800 border-pink-300',
    gray: 'bg-gray-100 text-gray-800 border-gray-300',
};
// Shipment status color mapping
export const shipmentStatusColors = {
    scheduled: 'green',
    accepted: 'green',
    in_progress: 'blue',
    job_closed: 'gray',
    default: 'gray',
};
// Billing status color mapping
export const billingStatusColors = {
    awaiting_billable_event: 'gray',
    ready_to_bill: 'blue',
    incomplete: 'red',
    billing_hold: 'red',
    audited: 'green',
    invoiced: 'green',
    default: 'gray',
};
// Leg type color mapping
export const legTypeColors = {
    full_container: 'blue',
    empty_container: 'green',
    chassis_split: 'purple',
    bobtail: 'yellow',
    dry_run: 'indigo',
    default: 'gray',
};
// Yard location addresses for hub types
export const yardLocationAddresses = {
    'Yard A': '123 Yard A Street, Los Angeles, CA 90001',
    'Yard B': '456 Yard B Avenue, Long Beach, CA 90802',
    'Yard C': '789 Yard C Boulevard, San Pedro, CA 90731',
};
// Equipment validation regex patterns
export const equipmentValidationPatterns = {
    chassis: /^[A-Za-z]{4}\d{6}$/,
    container: /^[A-Za-z]{4}\d{7}$/,
    trailer: /^[A-Za-z]{4}\d{6}$/,
};
// Equipment validation messages
export const equipmentValidationMessages = {
    chassis: 'Chassis must be 4 letters followed by 6 numbers (10 characters total)',
    container: 'Container must be 4 letters followed by 7 numbers (11 characters total)',
    trailer: 'Trailer must be 4 letters followed by 6 numbers (10 characters total)',
};
export const EQUIPMENT_VALIDATION = {
    Container: {
        pattern: equipmentValidationPatterns.container,
        message: equipmentValidationMessages.container,
    },
    Chassis: {
        pattern: equipmentValidationPatterns.chassis,
        message: equipmentValidationMessages.chassis,
    },
    Trailer: {
        pattern: equipmentValidationPatterns.trailer,
        message: equipmentValidationMessages.trailer,
    },
};
// Common yard locations for hub name suggestions
export const commonYardLocations = [
    'APM Terminal',
    'Port of Los Angeles',
    'Port of Long Beach',
    'Port of NY/NJ',
    'Port of Savannah',
    'Port of Charleston',
    'Port of Houston',
    'Port of Seattle',
    'Norfolk International Terminal',
    'Virginia International Gateway',
    'Georgia Ports Authority',
    'Port of Oakland',
    'Port of Tacoma',
    'Port of Baltimore',
    'Port of Miami',
    'Port of New Orleans',
    'Maher Terminals',
    'Global Container Terminal',
    'Everport Terminal',
    'TraPac Terminal',
    'Fenix Marine Services',
    'SSA Marine',
    'PNCT Terminal',
    'GCT Bayonne',
    'Red Hook Container Terminal',
];
